import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledTimeline = styled(Stack)({
  gap: 0,
  position: "relative",
  paddingLeft: 20,
  "&::before": {
    content: '""',
    position: "absolute",
    left: 7,
    top: 8,
    bottom: 8,
    width: 2,
    borderRadius: 1,
    backgroundColor: "rgba(0,0,0,0.08)",
  },
});

export const StyledTimelineItem = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: 10,
  padding: "10px 0",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    left: -15,
    top: 19,
    width: 6,
    height: 6,
    borderRadius: "50%",
    backgroundColor: theme.palette.hubColors.mainFocus,
    outline: `3px solid ${theme.palette.hubColors.mainFocusLighter}`,
  },
}));

export const StyledFieldChange = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: 8,
  alignItems: "center",
  padding: "2px 6px",
  borderRadius: 4,
  backgroundColor: theme.palette.hubColors.greyLightest,
}));
